import "./styles.scss";

import { useTranslation } from "react-i18next";

import DashboardContentLayout from "components/layouts/DashboardContentLayout";
import useResponsive from "libs/helpers/useResponsive";

import { useClients } from "context/admin/clients";
import { ClientsTable, ClientsTiles } from "./components";

const actions = [
  {
    type: "send_notification",
  },
  {
    type: "create_task",
  },
];

const mainClass = "clients-admin-content";

const ClientsContent = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { data, loading, init_loading, filters, filterHandler } = useClients();

  return (
    <DashboardContentLayout
      header={{
        label: t("Clients"),
        description: t("Accounts with an active subscription."),
      }}
      loading={init_loading}
      actions={actions}
    >
      <div className={mainClass}>
        {!max.lg ? (
          <ClientsTable
            data={data}
            loading={!!loading}
            filters={filters}
            filterHandler={filterHandler}
          />
        ) : (
          <ClientsTiles data={data} loading={!!loading} />
        )}
      </div>
    </DashboardContentLayout>
  );
};

export default ClientsContent;
